import React, { useState } from 'react';
import { Cloud, X } from 'lucide-react';
import { ROUTES } from '@config/constants';

interface DropboxAuthProps {
  clientId: string;
  /** Rückweg nach dem OAuth (z.B. /settings). Tab „Erweitert“ wird per sessionStorage gesetzt. */
  returnPath?: string;
  onAuthSuccess: (accessToken: string) => void;
  onCancel: () => void;
}

const DROPBOX_CALLBACK_URI = typeof window !== 'undefined'
  ? `${window.location.origin}${ROUTES.DROPBOX_CALLBACK}`
  : '';

export const DropboxAuth: React.FC<DropboxAuthProps> = ({
  clientId,
  returnPath = ROUTES.SETTINGS,
  onCancel,
}) => {
  const [error, setError] = useState<string | null>(null);

  const handleAuth = () => {
    setError(null);
    if (!clientId?.trim()) {
      setError('VITE_DROPBOX_CLIENT_ID fehlt in der .env.');
      return;
    }
    const redirectUri = DROPBOX_CALLBACK_URI || `${window.location.origin}${ROUTES.DROPBOX_CALLBACK}`;
    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: 'code',
      token_access_type: 'offline',
      state: returnPath,
    });
    const authUrl = `https://www.dropbox.com/oauth2/authorize?${params.toString()}`;
    window.location.href = authUrl;
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-dela text-xl text-white flex items-center gap-2">
          <Cloud className="w-6 h-6 text-primary" />
          Connect Dropbox
        </h3>
        <button
          type="button"
          onClick={onCancel}
          className="p-2 text-white/60 hover:text-white hover:bg-white/10 rounded-lg transition-all"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {error && (
        <div className="p-4 bg-red-500/20 border border-red-500/50 rounded-lg text-red-200">
          <p className="font-inter font-bold">{error}</p>
        </div>
      )}

      <div className="text-center py-8 space-y-4">
        <Cloud className="w-16 h-16 text-primary mx-auto" />
        <p className="text-white/80 font-inter">Connect Dropbox to import files</p>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleAuth();
          }}
          className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg transition-all text-white font-codec font-bold flex items-center gap-2 mx-auto"
        >
          <Cloud className="w-5 h-5" />
          Connect with Dropbox
        </button>
      </div>
    </div>
  );
};
